module.exports = __webpack_public_path__ + "static/media/38-10.7fffb7ed.mp3";